import OATPrice from './price'
import Value from './option-value'

export default class Option {
  constructor({ basePrice, code, id, hasValues, isMultiple, isMultipleSame, min, max, name, required, values, variationPrice }) {
    this.basePrice = basePrice;
    this.code = code;
    this.id = id;
    this.hasValues = hasValues;
    this.isMultiple = isMultiple;
    this.isMultipleSame = isMultipleSame;
    this.min = min;
    this.max = max;
    this.name = name;
    this.required = required;
    this.values = values.map(v => {
      return !(v instanceof Value) ? new Value(Value.format(v)) : v;
    });
    this.variationPrice = variationPrice;
    this.price;
  }

  get price() { 
    const prices = [this.basePrice + this.variationPrice];
    return new OATPrice({prices});
  }

  static format(option) {
    return {
      basePrice: option.base_price,
      code: option.code,
      id: option.id,
      hasValues: option.has_available_values,
      isMultiple: option.allow_multiple,
      isMultipleSame: option.allow_multiple_same_item,
      max: option.max_selected_values !== null ? parseFloat(option.max_selected_values) : null,
      min: option.min_selected_values !== null ? parseFloat(option.min_selected_values) : null,
      name: option.title,
      required: option.is_required,
      values: option.available_values,
      variationPrice: option.price_variation
    };
  }

  static fromJSON(json) {
    const values = json.values.map(v => Value.fromJSON(v));
    return new Option({
      basePrice: json.basePrice,
      code: json.code,
      id: json.id,
      hasValues: json.hasValues,
      isMultiple: json.isMultiple,
      isMultipleSame: json.isMultipleSame,
      max: json.max,
      min: json.min,
      name: json.name,
      required: json.required,
      values: values,
      variationPrice: json.variationPrice
    });
  }
} 